import React, { useState } from "react"
import { connect } from "react-redux"
import "pages/Styles/ProfileV2.sass"

import { $moment } from "funcs"
import InfoButton from "../../components/InfoButton"
import Popup from "../../components/Popup"
import EnterTextPopup from "../Common/EnterTextPopup"
import {httpClient} from "../../funcs"
import {notifyAboutError, notifyUser} from "../../methods/notifyUser"
import {ReactComponent as Edit} from "../Icons/size24/Edit.svg"
import {
  hasOgrnField,
  normalizeJurisdictionCode,
  ogrnLabel,
  taxIdLabel,
} from "../../methods/jurisdictionIdentifiers";
import { sanitizeSignatureHtml } from "../../utils/sanitizeHtml";
import { missingRequisitesClientWarning } from "../Contracts/ContractView/initiatorTrustCriteria";

let UserFields: any = function UserFields(props: any) {
  const [representativeBasisInfoOpen, setRepresentativeBasisInfoOpen] = useState(false)
  const [representativeBasisEditOpen, setRepresentativeBasisEditOpen] = useState(false)

  const isEmployeeInBusiness = !!props.$store.userSession?.role_id
  const currentOverride = (props.$store.userSession?.employee_role?.first_signer_representative_basis_override ?? '').toString()

  function makeEntrepreneurDataView() {
    const representativeBasisValue = props.$store.userSession.representative_basis || '—'
    const employeeOverrideValue = currentOverride.length > 0 ? currentOverride : '—'
    const jurisdiction = normalizeJurisdictionCode(props.$store.userSession?.jurisdiction)
    const taxLabel = taxIdLabel(jurisdiction, 'entrepreneur')

    return <div className="profile-section-card ui-kit-v2" style={{marginTop: "15px"}}>
      <div className="profile-section-label">
        Данные юр. лица:
      </div>

      <div className="profile-section-field">
        <div className="profile-section-field-label">Полное наименование юр. лица:</div>
        <div className="profile-section-field-value">{props.$store.userSession.law_name}</div>
      </div>

      {
        !isEmployeeInBusiness &&
        <div className="profile-section-field">
          <div
            className="profile-section-field-label"
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <span>В лице / основание полномочий:</span>
            <InfoButton
              size="small"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setRepresentativeBasisInfoOpen(true)
              }}
            />
          </div>
          <div className="profile-section-field-value">
            {representativeBasisValue}
          </div>
        </div>
      }

      {
        isEmployeeInBusiness &&
        <>
          <div className="profile-section-field">
            <div
              className="profile-section-field-label"
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <span>В лице / основание полномочий (основной подписант):</span>
              <InfoButton
                size="small"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setRepresentativeBasisInfoOpen(true)
                }}
              />
            </div>
            <div className="profile-section-field-value">
              {representativeBasisValue}
            </div>
          </div>

          <div className="profile-section-field">
            <div
              className="profile-section-field-label"
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <span>В лице / основание полномочий (для вас, как сотрудника):</span>
              <button
                className="update-user-fields-edit-btn ui-kit-v2-button"
                style={{ marginRight: "0px" }}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setRepresentativeBasisEditOpen(true)
                }}
              >
                <Edit />
              </button>
            </div>
            <div className="profile-section-field-value">
              {employeeOverrideValue}
            </div>
            <div className="Body_16_v2_secondary" style={{ marginTop: "6px" }}>
              Если поле пустое, будет использоваться значение из бизнес‑аккаунта.
            </div>
          </div>
        </>
      }

      <div className="profile-section-field">
        <div className="profile-section-field-label">Адрес регистрации:</div>
        <div className="profile-section-field-value">{props.$store.userSession.law_address}</div>
      </div>

      <div className="profile-section-field">
        <div className="profile-section-field-label">{taxLabel}:</div>
        <div className="profile-section-field-value">
          {props.$store.userSession.tax_id || "Не указан"}
        </div>
      </div>

      {
          hasOgrnField(jurisdiction) &&
          <div className="profile-section-field">
            <div className="profile-section-field-label">{ogrnLabel()}:</div>
            <div className="profile-section-field-value">
              {props.$store.userSession.ogrn?.length > 0 ? props.$store.userSession.ogrn : "Не указан"}
            </div>
          </div>
      }
      {missingProfileRequisitesHint()}
    </div>
  }

  function missingProfileRequisitesHint() {
    const taxEmpty = !props.$store.userSession.tax_id
    const showOgrn = hasOgrnField(normalizeJurisdictionCode(props.$store.userSession?.jurisdiction))
    const ogrnEmpty = showOgrn && !(props.$store.userSession.ogrn?.length > 0)
    if (!taxEmpty && !ogrnEmpty) {
      return null
    }
    const names = [
      taxEmpty ? taxIdLabel(normalizeJurisdictionCode(props.$store.userSession?.jurisdiction), "entrepreneur") : null,
      ogrnEmpty ? ogrnLabel() : null,
    ].filter(Boolean).join(" и ")
    return (
      <div className="Body_16_v2_secondary" style={{marginTop: "6px"}}>
        {missingRequisitesClientWarning(names)}
      </div>
    )
  }

  function passportView() {
    const passport = props.$store.userSession.passport;

    if (!passport) {
      return null
    }

    if (!passport.number) {
      return null
    }

    return <div className="profile-section-card ui-kit-v2" style={{marginTop: "15px"}}>
      <div className="profile-section-label">
        Паспортные данные:
      </div>

      <div className="profile-section-field">
        <div className="profile-section-field-label">Серия и номер:</div>
        <div className="profile-section-field-value">{passport.number}</div>
      </div>
      {
        passport.issued_by_code &&
        <div className="profile-section-field">
          <div className="profile-section-field-label">Код подразделения:</div>
          <div className="profile-section-field-value">{passport.issued_by_code}</div>
        </div>
      }
      {
          passport.issued_at &&
          <div className="profile-section-field">
            <div className="profile-section-field-label">Дата выдачи паспорта:</div>
            <div className="profile-section-field-value">{$moment(passport.issued_at).format('LL')}</div>
          </div>
      }
    </div>
  }
  
  function stampAndSignatureView() {
    const organisation_stamp = props.$store.userSession.organisation_stamp
    const signature = props.$store.userSession.passport?.signature
    const showOrganisationStamp = props.$store.userSession.role !== 'customer'
    
    // Проверяем наличие печати (может быть base64 или URL)
    const hasStamp = showOrganisationStamp && organisation_stamp && 
      (typeof organisation_stamp === 'string' && organisation_stamp.trim().length > 0)
    
    // Проверяем наличие подписи (может быть base64, URL или HTML строка)
    const hasSignature = signature && 
      (typeof signature === 'string' && signature.trim().length > 0)
    
    if (!hasStamp && !hasSignature) {
      return null
    }
    
    const MAX_WIDTH_OR_HEIGHT = 300
    
    return <div className="profile-section-card ui-kit-v2" style={{marginTop: "15px"}}>
      <div className="profile-section-label">
        {showOrganisationStamp ? "Печать и подпись:" : "Подпись:"}
      </div>
      
      <div style={{marginTop: "20px"}}>
        {hasStamp && hasSignature ? (
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px"
          }}>
            <div style={{width: "50%"}}>
              <div className="profile-section-field-label" style={{marginBottom: "10px"}}>Печать организации:</div>
              <img
                style={{
                  height: "auto",
                  maxHeight: MAX_WIDTH_OR_HEIGHT,
                  width: "40%",
                  maxWidth: MAX_WIDTH_OR_HEIGHT
                }}
                src={organisation_stamp}
                alt={"Печать"}
              />
            </div>
            <div style={{width: "50%"}}>
              <div className="profile-section-field-label" style={{marginBottom: "10px"}}>Рукописная подпись:</div>
              {signature && typeof signature === 'string' && signature.trim().startsWith('<img') ? (
                <div dangerouslySetInnerHTML={{ __html: sanitizeSignatureHtml(signature.replace('style="', 'style="width: 40%; height: auto; max-height: 300px; ')) }} />
              ) : (
                <img
                  style={{
                    height: "auto",
                    maxHeight: MAX_WIDTH_OR_HEIGHT,
                    width: "40%",
                    maxWidth: MAX_WIDTH_OR_HEIGHT
                  }}
                  src={signature}
                  alt={"Подпись"}
                />
              )}
            </div>
          </div>
        ) : hasStamp ? (
          <div>
            <div className="profile-section-field-label" style={{marginBottom: "10px"}}>Печать организации:</div>
            <img
              style={{
                height: "auto",
                maxHeight: MAX_WIDTH_OR_HEIGHT,
                width: "40%",
                maxWidth: MAX_WIDTH_OR_HEIGHT
              }}
              src={organisation_stamp}
              alt={"Печать"}
            />
          </div>
        ) : hasSignature ? (
          <div>
            <div className="profile-section-field-label" style={{marginBottom: "10px"}}>Рукописная подпись:</div>
            {signature && typeof signature === 'string' && signature.trim().startsWith('<img') ? (
              <div dangerouslySetInnerHTML={{ __html: sanitizeSignatureHtml(signature.replace('style="', 'style="width: 40%; height: auto; max-height: 300px; ')) }} />
            ) : (
              <img
                style={{
                  height: "auto",
                  maxHeight: MAX_WIDTH_OR_HEIGHT,
                  width: "40%",
                  maxWidth: MAX_WIDTH_OR_HEIGHT
                }}
                src={signature}
                alt={"Подпись"}
              />
            )}
          </div>
        ) : null}
      </div>
    </div>
  }

  // Render
  const jurisdiction = normalizeJurisdictionCode(props.$store.userSession?.jurisdiction)
  const customerTaxLabel = taxIdLabel(jurisdiction, 'customer')

  return (
    <div>
      {props.$store.userSession ? (
        <>
          <div className="profile-section-card ui-kit-v2">
            <div className="profile-section-label">
              Основная информация:
            </div>
            <div className="profile-section-field">
              <div className="profile-section-field-label">Номер телефона:</div>
              <div className="profile-section-field-value">{props.$store.userSession.phone_number}</div>
            </div>
            {
                props.$store.userSession.additional_phone_number &&
                <div className="profile-section-field">
                  <div className="profile-section-field-label">Телефон для клиентов:</div>
                  <div className="profile-section-field-value">{props.$store.userSession.additional_phone_number}</div>
                </div>
            }

            <div className="profile-section-field">
              <div className="profile-section-field-label">E-Mail:</div>
              <div className="profile-section-field-value">{props.$store.userSession.email}</div>
            </div>

            {
                props.$store.userSession.role == 'customer' && props.$store.userSession.birth_date &&
                <div className="profile-section-field">
                  <div className="profile-section-field-label">Дата рождения:</div>
                  <div className="profile-section-field-value">{$moment(props.$store.userSession.birth_date).format('LL')}</div>
                </div>
            }

            {
                props.$store.userSession.role == 'customer' && props.$store.userSession.law_address &&
                <div className="profile-section-field">
                  <div className="profile-section-field-label">Адрес регистрации:</div>
                  <div className="profile-section-field-value">{props.$store.userSession.law_address}</div>
                </div>
            }

            {
                props.$store.userSession.role == 'customer' && props.$store.userSession.tax_id &&
                <div className="profile-section-field">
                  <div className="profile-section-field-label">{customerTaxLabel}:</div>
                  <div className="profile-section-field-value">{props.$store.userSession.tax_id}</div>
                </div>
            }
          </div>

          {
              props.$store.userSession.role == 'entrepreneur' &&
              makeEntrepreneurDataView()
          }

          {
            representativeBasisInfoOpen &&
            <Popup onClose={() => setRepresentativeBasisInfoOpen(false)}>
              <div className="ui-kit-v2">
                <div className="popup-title">В лице / основание полномочий</div>
                <div className="Body_16_v2" style={{ marginTop: "10px" }}>
                  Это значение используется в шапке договора после названия организации, например: «в лице директора Иванова И.И., действующего на основании Устава».
                </div>
              </div>
            </Popup>
          }

          {
            representativeBasisEditOpen &&
            <EnterTextPopup
              title="Переопределение для вас (как сотрудника)"
              placeholder="Например: в лице директора Иванова И.И., действующего на основании Устава"
              oldText={currentOverride}
              canSaveEmpty={true}
              onClose={() => setRepresentativeBasisEditOpen(false)}
              saveNewName={async (newText: string) => {
                try {
                  await httpClient.patch('/update-my-role', {
                    first_signer_representative_basis_override: newText
                  })
                  notifyUser(props, "Сохранено")
                  setRepresentativeBasisEditOpen(false)
                  setTimeout(() => location.reload(), 200)
                } catch (err) {
                  notifyAboutError(props, err)
                }
              }}
            />
          }

          {
            passportView()
          }

          {
            stampAndSignatureView()
          }
        </>
      ) : null}
    </div>
  )
}

UserFields = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
      $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(UserFields)

export default UserFields
